import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";
import { blogPage, home } from "@faire/retailer-visitor-shared/paths/index";
import { MakerSignUpMobileWrapper } from "@faire/retailer/views/apply/MakerApplication/MakerSignUp/MakerSignUpMobileWrapper";
import { MakerSignUpWrapper } from "@faire/retailer/views/apply/MakerApplication/MakerSignUp/MakerSignUpWrapper";
export var SubmitPageStage;
(function(SubmitPageStage) {
    SubmitPageStage[SubmitPageStage["WAITLISTED"] = 1] = "WAITLISTED";
    SubmitPageStage[SubmitPageStage["UNSUPPORTED_AREA"] = 2] = "UNSUPPORTED_AREA";
})(SubmitPageStage || (SubmitPageStage = {}));
export var MakerSignUpNotAccepted = function(param) {
    var currentPage = param.currentPage, onClickTellUsMore = param.onClickTellUsMore;
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        mobile: /*#__PURE__*/ _jsx(MakerSignUpMobileWrapper, {
            children: /*#__PURE__*/ _jsxs(PageWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Content, {
                        currentPage: currentPage,
                        hasCTA: !!onClickTellUsMore
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "3x"
                    }),
                    /*#__PURE__*/ _jsx(CTA, {
                        onClickTellUsMore: onClickTellUsMore
                    })
                ]
            })
        }),
        tabletAndAbove: /*#__PURE__*/ _jsx(MakerSignUpWrapper, {
            children: /*#__PURE__*/ _jsxs(PageWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Content, {
                        currentPage: currentPage,
                        hasCTA: !!onClickTellUsMore
                    }),
                    /*#__PURE__*/ _jsx(CTA, {
                        onClickTellUsMore: onClickTellUsMore
                    })
                ]
            })
        })
    });
};
var Content = function(param) {
    var currentPage = param.currentPage, hasCTA = param.hasCTA;
    return /*#__PURE__*/ _jsxs(Column, {
        "data-test-id": "waitlisted-message",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "displayMSerifRegular",
                children: currentPage === SubmitPageStage.WAITLISTED ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "413yfN",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You've been added to our waitlist"
                        }
                    ]
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "WBrCMD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Faire isn't available in your area yet"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: currentPage === SubmitPageStage.WAITLISTED ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "gyfqQL",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Our team will review your information and let you know if your shop is approved within 30 days. If you don't hear from us by then, it means we can't launch your shop on Faire right now - we\u2019ll reach out if anything changes. In the meantime, you can add more details on the next page."
                        }
                    ]
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "Rxu4RQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Thank you for submitting your info! Unfortunately, we aren't in your area yet. Once we are, we'll reach out to you so you can set up your shop on Faire."
                        }
                    ]
                })
            }),
            !hasCTA ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "2x"
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "vuTE9W",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "In the meantime, if you'd like to learn a little bit more about how brands use Faire for their wholesale business, you can visit our blog."
                                }
                            ]
                        })
                    })
                ]
            }) : null
        ]
    });
};
var CTA = function(param) {
    var onClickTellUsMore = param.onClickTellUsMore;
    var _useLocalization = useLocalization(), locale = _useLocalization.intl.locale;
    if (onClickTellUsMore) {
        return /*#__PURE__*/ _jsx(CTAButton, {
            onClick: onClickTellUsMore,
            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "ObPhAN",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Add more details"
                    }
                ]
            })
        });
    }
    return /*#__PURE__*/ _jsxs(ButtonWrapper, {
        children: [
            /*#__PURE__*/ _jsx(CTAButton, {
                linkTo: "".concat(blogPage(locale), "/thestudio/"),
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "3+QF6y",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Go to Faire Blog"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "tertiary",
                linkTo: home(),
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "WC1ER4",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Return to Faire.com"
                        }
                    ]
                })
            })
        ]
    });
};
var ButtonWrapper = styled(Column).attrs({
    align: {
        mobileAndAbove: "center",
        tabletAndAbove: "flex-start"
    }
}).withConfig({
    componentId: "sc-9cd8f748-0"
})([
    "width:100%;"
]);
var PageWrapper = styled(Column).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-9cd8f748-1"
})([
    "",
    "{min-height:500px;}",
    "{padding:",
    ";}"
], responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.mobile, getSpacing("3x"));
var CTAButton = styled(Button).attrs({
    variant: "primary"
}).withConfig({
    componentId: "sc-9cd8f748-2"
})([
    "width:fit-content;min-width:250px;",
    "{width:100%;}"
], responsiveMediaQueries.mobile);
